// components/PrefacturaCard.js
import { Box, Paper, Typography, Grid, Alert, Button } from '@mui/material';
import ReceiptIcon from '@mui/icons-material/Receipt';
import { formatImporte } from '../utils/formatters';

export const PrefacturaCard = ({ 
  calculando, 
  error, 
  totalNeto, 
  ivaCalculado, 
  percepciones, 
  totalFinal, 
  onReintentar 
}) => {
  return (
    <Paper elevation={3} sx={{ p: 2, mb: 3, borderRadius: 2, bgcolor: '#f8f9fa' }}>
      <Box display="flex" alignItems="center" mb={2}>
        <ReceiptIcon sx={{ mr: 1, color: '#2E86C1' }} />
        <Typography variant="h6" fontWeight="bold" color="#2E86C1">
          Resumen de Prefactura
        </Typography>
      </Box>
      
      {calculando ? (
        <Typography variant="body2" color="textSecondary">Calculando...</Typography>
      ) : error ? (
        <Alert severity="error" size="small">
          Error: {error}
          <Button size="small" onClick={onReintentar} sx={{ ml: 2 }}>
            Reintentar
          </Button>
        </Alert>
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={6} sm={3}>
            <Typography variant="caption" color="textSecondary">Neto Gravado</Typography>
            <Typography variant="subtitle1" fontWeight="bold">${formatImporte(totalNeto)}</Typography>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Typography variant="caption" color="textSecondary">IVA (21%)</Typography>
            <Typography variant="subtitle1" fontWeight="bold">${formatImporte(ivaCalculado)}</Typography>
          </Grid>
          {percepciones && percepciones !== 0 && (
            <Grid item xs={6} sm={3}>
              <Typography variant="caption" color="textSecondary">Percepciones</Typography>
              <Typography variant="subtitle1" fontWeight="bold" color="#E67E22">
                ${formatImporte(percepciones)}
              </Typography>
            </Grid>
          )}
          <Grid item xs={6} sm={3}>
            <Typography variant="caption" color="textSecondary">Total a Pagar</Typography>
            <Typography variant="h6" fontWeight="bold" color="#27AE60">
              ${formatImporte(totalFinal)}
            </Typography>
          </Grid>
        </Grid>
      )}
    </Paper>
  );
};